export default __webpack_public_path__ + "static/media/step2-8.8cee54a3.png";